<template>
    <div ref="myCardViewDom" class="full-width padding-box" v-loading="loading" :style="styleObj">
        <el-scrollbar>

        <HomeHeader
            :returnLabel="returnBtnLabel"
            :useChatBtn="true"
            @clickBackBtn="return3DCity"
            @clickChatBtn="openChatPart"
            v-if="usePageHeader !== false"
        />

        <div v-show="viewPart == 'card'">
            <!--  头部的操作栏  -->
            <div class="header-btn-part">
                <div>
                    <selectDepartGroup :departmentList="departmentList" @clickDPBtn="fillSelectCardList" />
                </div>

                <div>
                    <!--            <el-button color="#8E44AD" @click="clickFunc">快速導引</el-button>-->
                    &nbsp;
                </div>
            </div>

            <div style="text-align: left; padding-left: 5px">
                <el-button plain color="#e91e63" size="small" @click="goBuyNFCCard" tkey="購買NFC名片">{{i18n.tkey("lang_buy_nfc_card")}}</el-button>
            </div>

            <!--  名片上方的操作欄  -->
            <div class="sub-header-btn-part">
                <div class="left-part">
                    &nbsp;
                </div>

                <div class="center-part">
<!--                    <goShopManageBtn v-if="null != userInfoRef.companyId && null != userInfoRef.acccompanycode" @click="showShopControl = true" />-->
<!--                    <openShopManageBtn v-if="null != userInfoRef.companyId && null == userInfoRef.acccompanycode" @click="openShopDialog" />-->
                    &nbsp;
                </div>

                <div class="right-part">
                    <cardSetting :card="currCard" @saveCardChange="saveCardSettingConfirm" v-if="null != currCard"/>
                    &nbsp;
                </div>
            </div>

            <!--  名片banner  -->
            <div class="banner-part-div">
                <myCardBanner :cardIndex="currIndex" :cardList="memberworkList" @changeIndex="changeIndexEvent"/>
            </div>

            <!--  名片操作欄  -->
            <div>
                <cardActionBar @clickAction="handleAction" />
            </div>
        </div>

        <div v-show="viewPart == 'card'">
            <!--  通讯录分割线  -->
            <!--    <el-affix :offset="0">-->
            <pageTitle :titleText="addressBookName" />
            <!--    </el-affix>-->

            <!--  名片夹  -->
            <myCardHolder :cardObj="currCard" />

            <!--  回到頂部  -->
            <el-backtop :bottom="30" />

            <!--  名片分享框  -->
            <cardShare />
        </div>

        <div v-if="viewPart == 'record5'">
            <record5Editor />
        </div>

        <!--  名片申請組件  -->
        <div class="my-drawer">
            <el-drawer
                    v-model="recordDrawer"
                    title="收錄請求"
                    :lock-scroll="true"
                    :size="drawWidth"
            >
                <el-scrollbar>
                    <cardRecordView />
                </el-scrollbar>

            </el-drawer>
        </div>

        <!--  編輯名片樣式的組件  -->
        <div v-if="null != currEditCardId" class="unvisible-savecard-iframe">
            <cardEditorIframe :id="currEditCardId" :tag="'saveCard'" @save-success="saveCardCallback" />
        </div>

        <!--  選擇部門名片的模態框  -->
        <div v-if="null != selectCardList">
            <selectDepartCardDialog :cardList="selectCardList" @closeDialog="closeDialog" />
        </div>

<!--        <el-dialog v-model="showChatView" title="Shopopee Chat" :width="chatDialogWidth" :top="'5vh'" draggable>-->
<!--            <div v-if="useChatView === true">-->
<!--                <chatComponent :width="chatWidth" :height="chatHeight" ref="chatIframeComponent" />-->
<!--            </div>-->
<!--        </el-dialog>-->

<!--        <chatFloatComponent ref="chatIframeComponent" v-show="showChatView" v-if="null != userInfoRef.token" @clickClose="showChatView = false" />-->

        <el-dialog v-model="showShopControl" @closed="closeDialogFunc" destroy-on-close :close-on-click-modal="false" :close-on-press-escape="false" title="" :width="myUtil.isMobile() ? '90%' : '600px'" top="5vh">
            <shopControllerView :showReturnBtn="false" />
        </el-dialog>

        <el-dialog
                v-model="editVisible"
                :title="i18n.tkey('lang_edit_staff')"
                :width="myUtil.isMobile() ? '90%' : '600px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <companyStaffEditor :editLogin="currCard.login" />
        </el-dialog>

        <el-dialog
                v-model="openShopVisible"
                :title="i18n.tkey('lang_open_shop_3d')"
                :width="myUtil.isMobile() ? '90%' : '600px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <companyShopInfoEditor :tag="'edit'" :countrycode="userInfoRef.country" @saveComplete="saveShopCallback" />
        </el-dialog>

        </el-scrollbar>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed, toRef, provide, inject, watch, onBeforeMount} from "vue";
    import selectDepartGroup from "@/components/shopopee/company/selectDepartGroup"
    import goShopManageBtn from "@/components/shopopee/button/goShopManageBtn"
    import openShopManageBtn from "@/components/shopopee/button/openShopManageBtn"
    import cardSetting from "@/components/shopopee/buttonGroup/cardSetting.vue"
    import myCardBanner from "@/components/shopopee/card/myCardBanner"
    import pageTitle from "@/components/shopopee/common/pageTitle"
    import myCardHolder from "@/components/shopopee/card/myCardHolder"
    import cardShare from "@/components/shopopee/share/cardShare"
    import cardActionBar from "@/components/shopopee/card/cardActionBar"
    import cardEditorIframe from "@/components/shopopee/card/cardEditorIframe"
    import cardRecordView from "@/views/cardRecordView"
    import selectDepartCardDialog from "@/components/shopopee/dialog/selectDepartCardDialog"
    import shopControllerView from "@/views/shopControllerView"
    import companyStaffEditor from "@/components/shopopee/company/companyStaffEditor"
    import chatFloatComponent from "@/components/shopopee/chat/chatFloatComponent"
    import companyShopInfoEditor from "@/components/shopopee/company/companyShopInfoEditor"
    import record5Editor from "@/components/shopopee/record5/record5Editor"
    import HomeHeader from "@/components/shopopee/pageHeader/homeHeader.vue";
    import quotationPrinter from "@/components/shopopee/print/quotationPrinter"
    import cardApi from "@/request/api"
    import {useUserinfo} from "@/stores/userinfo";
    import {useCompanyinfo} from "@/stores/companyinfo"
    import {ElMessage} from "element-plus";
    import myUtil from "@/util/util"
    import { ArrowLeft } from '@element-plus/icons-vue'
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faComments } from '@fortawesome/free-solid-svg-icons'
    import {usePageinfo} from "@/stores/pageinfo";
    import cookie from "@/util/cookie";

    library.add(faComments)

    const i18n = inject("i18n")

    const { proxy } = getCurrentInstance();

    const props = defineProps(['useChat', 'usePageHeader'])

    const staticPath = process.env.BASE_URL

    const windowInnerWidth = ref((window.innerWidth) + "px")
    const windowInnerHeight = ref((window.innerHeight) + "px")

    const styleObj = ref({})

    //組件寬度
    const width = ref(425)
    //名片請求框寬度
    const drawWidth = ref("90%")

    const { openPersonChat } = inject('phoneView', { openPersonChat: openCardChat })
    const { goRecord5Editor } = inject('phoneView', { goRecord5Editor: () => { viewPart.value = "record5" } })
    const { goCardEditorView } = inject('phoneView', { goCardEditorView: clickEditorButton })

    const showChatView = ref(true)
    const showShopControl = ref(false)
    const useChatView = ref(false)
    const chatDialogWidth = ref("465px")
    const chatWidth = ref("425px")
    const chatHeight = ref("425px")

    const loading = ref(false)

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())
    //響應機制的companyinfo
    const companyInfoRef = toRef(useCompanyinfo())
    //響應機制的pageInfo
    const pageInfoRef = toRef(usePageinfo())

    //进入页面时的链接参数
    const pageInfoObj = {}
    //頁面顯示區域
    const viewPart = ref("card")

    //部門參數對象
    const departObj = ref({})
    //部門列表
    const departmentList = ref([])

    //名片列表
    const memberworkList = ref([])
    //名片序号
    const currIndex = ref(0)
    //当前名片
    const currCard = ref(null)

    //目前要编辑的名片id
    const currEditCardId = ref(null)

    //是否顯示名片收錄請求
    const recordDrawer = ref(true)

    //選擇的部門對象
    const selectDepartObj = ref(null)
    //選擇的部門名片
    const selectCardList = ref(null)

    //當前通訊錄
    const addressBookName = computed(() => {
        let text = "我的通訊錄"

        // if (null != memberworkList.value && Array.isArray(memberworkList.value) && null != memberworkList.value[currIndex.value]){
        //     if (memberworkList.value[currIndex.value].login !== userInfoRef.value.login){
        //         text = `${memberworkList.value[currIndex.value].name}的通訊錄`
        //     }
        // }

        text = i18n.tkey("lang_Address_book")   //通訊錄

        return text
    })

    //返回按钮的文字
    const returnBtnLabel = computed(() => {
        let text = i18n.tkey("lang_return")

        if (viewPart.value === "card") {
            text = i18n.tkey("lang_return")
        }

        if (viewPart.value === "record5") {
            text = i18n.tkey("lang_my_memberwork")
        }

        return text

    })

    //是否顯示修改員工
    const editVisible = ref(false)
    //是否顯示開通店鋪
    const openShopVisible = ref(false)
    //頁面是否默認打開開通店鋪
    const openShopTag = ref(false)

    function queryDepartMemberwork(callback) {
        cardApi.queryDepartMemberwork.send(departObj.value, callback)
    }

    function fillDepartMemberwork(res) {
        if (res.code == "200") {
            let detail = res.detail

            fillDepartmentList(detail)

        }else{
            ElMessage({
                showClose: true,
                message: res.msg,
                type: 'success',
                offset: 180
            })
        }
    }

    function fillDepartmentList(detail) {
        let list = detail.list
        delete detail.list
        if (myUtil.isNotEmpty(detail.id)){
            myUtil.mergeObj(detail, companyInfoRef.value)
        }

        list.forEach(function (value, index) {
            //第一個是自己部門
            if (index == 0){
                memberworkList.value = value.memberworkList
                currCard.value = transformCardSetting(value.memberworkList[currIndex.value])
            }
            delete value.memberworkList
        })

        departmentList.value = list

        if (openShopTag.value == true){
            openShopTag.value = false
            openShopVisible.value = true
        }

        if (pageInfoObj.editStaff == true){
            delete pageInfoObj.editStaff
            editVisible.value = true
        }
    }

    function changeIndexEvent(index){
        currIndex.value = index
        currCard.value = transformCardSetting(memberworkList.value[index])
    }

    function transformCardSetting(obj) {
        const card = {}
        myUtil.mergeObj(obj, card)
        card.cardSetting = {}

        if (myUtil.isNotEmpty(obj.addinfo7)){
            card.cardSetting = JSON.parse(obj.addinfo7)
        }

        return card
    }

    //保存名片設置詢問
    function saveCardSettingConfirm(obj){
        let confirmText = ""

        if (obj.hasOwnProperty("isShowPhone")){
            if (obj.isShowPhone == -1){
                confirmText = i18n.tkey("lang_not_disclose_phone_card")
            }else{
                confirmText = i18n.tkey("lang_open_disclose_phone_card")
            }
        }

        if (obj.hasOwnProperty("isShowCard")){
            if (obj.isShowCard == -1){
                confirmText = i18n.tkey("lang_not_disclose_card")
            }else{
                confirmText = i18n.tkey("lang_open_disclose_card")
            }
        }

        myUtil.confirmInfo(confirmText, () => {
            saveCardSetting(obj)
        })
    }

    function saveCardSetting(obj){
        myUtil.mergeObj(obj, currCard.value.cardSetting)
        currCard.value.addinfo7 = JSON.stringify(currCard.value.cardSetting)

        currCard.value.workcurrent = currCard.value.cardSetting.isShowPhone

        updateCard()
    }

    function updateCard(){
        const request = cardApi.update

        loading.value = true

        request.send(
            currCard.value,
            (res) => {
                if (res.code == 200){
                    currEditCardId.value = currCard.value.id
                }else{
                    myUtil.alertError(res.msg)
                    loading.value = false
                }

            },
            () => {
                loading.value = false
            },
            () => {
                loading.value = false
            }
        )
    }

    function saveCardCallback(){
        myUtil.alertSuccess(i18n.tkey("lang_save_success"))
        loading.value = false
        currEditCardId.value = null

        queryDepartMemberwork(fillDepartMemberwork)
    }

    function handleAction(name){
        if (name === "cardRecord"){
            recordDrawer.value = true
        }

        if (name === "editUser"){
            editVisible.value = true
        }

        if (name === "editNews"){
            goRecord5Editor()
        }

        if (name === "editCard"){
            goCardEditorView()
        }
    }

    function fillSelectCardList(obj){
        if(obj.list.length > 0 && obj.list[0].memberworkList != null){
            selectDepartObj.value = obj
            selectCardList.value = obj.list[0].memberworkList
        }else{
            selectDepartObj.value = null
            selectCardList.value = null
        }
    }

    function closeDialog(){
        selectDepartObj.value = null
        selectCardList.value = null
    }

    function changeDepart(index){
        const obj = selectDepartObj.value

        selectDepartObj.value = null
        selectCardList.value = null

        currIndex.value = index

        fillDepartmentList(obj)
    }

    function clickCardChatBtn(login){
        openPersonChat(login)
    }

    function openCardChat(login){
        // showChatView.value = true
        // proxy.$refs.chatIframeComponent.openPersonChat(login)
        pageInfoRef.value.chatLogin = login
        proxy.$router.push({
            name: "chat"
        })
    }

    function goBuyNFCCard(){
        location.href = `${proxy.$ShopopeeUrl}apply_card_paid?id=${memberworkList.value[currIndex.value].id}`
    }

    function getCurrCard(){
        return currCard.value
    }

    function reloadData(){
        queryDepartMemberwork(fillDepartMemberwork)
    }

    function updateAddinfo1(addinfo1){
        currCard.value.addinfo1 = addinfo1
    }

    function updateCardWhatsapp(worksalary, workjobduties){
        currCard.value.worksalary = worksalary
        currCard.value.workjobduties = workjobduties
    }

    function return3DCity(){
        if (viewPart.value == "card"){
            // proxy.$router.push({name: `demoIndex2`})
            proxy.$router.push({name: "home"})
        }else{
            viewPart.value = "card"
        }

    }

    function openChatPart(){
        // showChatView.value = true
    }

    function saveShopCallback(){
        myUtil.confirmSuccess(
            i18n.tkey("lang_create_shop_success_alert"),
            () => {
                proxy.$router.push({path: `/loading/myCard-shopController`})
            },
            () => {
                proxy.$router.push({path: `/loading/myCard`})
            }
        )
    }

    function openShopDialog(){
        openShopVisible.value = true
    }

    function closeDialogFunc(){
        queryDepartMemberwork(fillDepartMemberwork)
    }

    function clickEditorButton(){
        proxy.$router.push({name: "cardEditor"})
    }

    provide('myCardViewFunc', {
        changeDepart,
        clickCardChatBtn,
        getCurrCard,
        reloadData,
        updateAddinfo1,
        updateCardWhatsapp
    })

    onBeforeMount(() => {
        recordDrawer.value = false
        departObj.value = cardApi.queryDepartMemberwork.getParams()

        if (null != pageInfoRef.value.infoJson){
            if (true === pageInfoRef.value.infoJson.shopController){
                showShopControl.value = true
            }

            if (true === pageInfoRef.value.infoJson.openShop){
                cookie.setCookie("login", null, {path: '/'})

                // openShopVisible.value = true
                if (null != userInfoRef.value.acccompanycode){
                    showShopControl.value = true
                }else{
                    openShopTag.value = true
                }

            }

            if (true == pageInfoRef.value.infoJson.editStaff){
                departObj.value.department = pageInfoRef.value.infoJson.department
                currIndex.value = pageInfoRef.value.infoJson.cardIndex

                pageInfoObj.currIndex = currIndex.value
                pageInfoObj.editStaff = true
            }

        }

        if (false != props.usePageHeader){
            styleObj.value = {width: windowInnerWidth, height: windowInnerHeight}
        }

        pageInfoRef.value.infoJson = {}
    })

    onMounted(() => {

        width.value = proxy.$refs.myCardViewDom.offsetWidth

        let drawPercent = 475 / width.value

        if (drawPercent > 0.9){
            drawWidth.value = "90%"
        }else{
            drawWidth.value = `${Math.floor(drawPercent * 100)}%`
        }

        if (null == props.useChat || true === props.useChat){
            if (width.value > 1024){
                chatDialogWidth.value = `941px`
                chatWidth.value = "901px"
                chatHeight.value = "650px"
            }else{
                chatDialogWidth.value = `${width.value}px`
                chatWidth.value = `${width.value - 40}px`
                chatHeight.value = `${proxy.$refs.myCardViewDom.offsetHeight}px`
            }

            useChatView.value = true
        }
        showChatView.value = false

        queryDepartMemberwork(fillDepartMemberwork)
    })
</script>

<style scoped>
    .header-btn-part {
        display: flex;
        justify-content: space-between;
    }

    .sub-header-btn-part {
        padding-top: 15px;
        padding-bottom: 10px;
        /*display: flex;*/
        /*justify-content: space-between;*/
        align-items: center;
        position: relative;

    }

    .sub-header-btn-part .left-part{
        position: absolute;
        top: 20px;
        left: 0;
    }

    .sub-header-btn-part .right-part{
        position: absolute;
        top: 20px;
        right: 0;
    }

    .sub-header-btn-part .center-part{
        margin: auto;
    }

    .banner-part-div {
        margin-bottom: 20px;
    }

    .unvisible-savecard-iframe {
        position: absolute;
        left: 0;
        top: 200vh;
        width: 900px;
        height: 900px;
        z-index: 9999;
    }

    .full-width {
        width: 100%;
        height: 100%;
    }

    .padding-box {
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;
    }
</style>
<style>
    .my-drawer .el-overlay  {
        position: absolute;
    }
</style>